import React from 'react';

const DashboardIcon = ({ fill, height = '15', width = '15' }) => (
  <svg width={width} height={height} viewBox="0 0 15 15" fill={fill || '#fff'}>
    <rect width="6.92297" height="8.99999" rx="1" fill={fill}/>
    <rect x="8.07715" y="6" width="6.92297" height="8.99999" rx="1" fill={fill}/>
    <rect x="8.07715" width="6.92297" height="5.14285" rx="1" fill={fill}/>
    <rect y="9.85706" width="6.92297" height="5.14285" rx="1" fill={fill}/>
  </svg>
);

export default DashboardIcon;
